////////LIBRARY/////////
import update from 'immutability-helper'
import { cloneDeep } from 'lodash'
///////COMPONENTS///////
import extendUpdate from '../../helpers/extendUpdate'
import ActionsTypes from '../../constants/ActionsTypes'

extendUpdate(update)

const rgpd = {
	[ActionsTypes.POST_SEARCH_CUTOMER]: (state) => {
		return update(state, {
			rgpd: {
				isLoading: {
					$set: true,
				},
				error: {
					$set: false,
				},
			},
			columns: {
				currentDir: {
					$set: '',
				},
				currentColumn: {
					$set: '',
				},
			},
		})
	},
	[ActionsTypes.POST_SEARCH_CUTOMER_SUCCESS]: (state, payload) => {
		let itemsConf = cloneDeep(payload.data.data.content)
		let status = cloneDeep(payload.data.status)

		return update(state, {
			rgpd: {
				status: {
					$set: status,
				},
				isLoading: {
					$set: false,
				},
				error: {
					$set: false,
				},
				items: {
					$set: itemsConf,
				},
				paging: {
					$set: payload.data.data,
				},
			},
		})
	},
	[ActionsTypes.POST_SEARCH_CUTOMER_FAILURE]: (state, payload) => {
		return update(state, {
			rgpd: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error.data,
				},
			},
		})
	},

	[ActionsTypes.POST_CUSTOMER_DATA]: (state) => {
		return update(state, {
			rgpd: {
				isLoading: {
					$set: true,
				},
				error: {
					$set: false,
				},
			},
		})
	},
	[ActionsTypes.POST_CUSTOMER_DATA_SUCCESS]: (state, payload) => {
		return update(state, {
			rgpd: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: false,
				},
				header: {
					$set: payload.data,
				},
			},
		})
	},
	[ActionsTypes.POST_CUSTOMER_DATA_FAILURE]: (state, payload) => {
		return update(state, {
			rgpd: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: false,
				},
			},
		})
	},

	[ActionsTypes.POST_ANONYMISE_DATA]: (state) => {
		return update(state, {
			rgpd: {
				isLoading: {
					$set: true,
				},
				error: {
					$set: false,
				},
				/*items:{
					$set:[]
				}*/
			},
		})
	},
	[ActionsTypes.POST_ANONYMISE_DATA_SUCCESS]: (state, payload) => {
		return update(state, {
			rgpd: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: false,
				},
				items: {
					$set: payload.data.content,
				},
			},
		})
	},
	[ActionsTypes.POST_ANONYMISE_DATA_FAILURE]: (state, payload) => {
		return update(state, {
			rgpd: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: false,
				},
			},
		})
	},
	[ActionsTypes.RESET_DATA_RGPD]: (state) => {
		return update(state, {
			rgpd: {
				items: {
					$set: [],
				},
				paging: {
					$set: {},
				},
				status: {
					$set: 0,
				},
			},
		})
	},
	[ActionsTypes.RESET_UNKNOWN_MAIL_ERROR]: (state) => {
		return update(state, {
			rgpd: {
				error: {
					$set: false,
				},
			},
		})
	},
}

export default rgpd
